// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/UserWorkingTimeModelService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { UserWorkingTimeModelDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import type { UserWorkingTimeModelCollectionDtoSchema } from "../Messages/Collections_pb";
import { file_Messages_Collections } from "../Messages/Collections_pb";
import type { UuidDtoSchema, UuidWithDeletedItemSelectionDtoSchema } from "../Messages/Common_pb";
import { file_Messages_Common } from "../Messages/Common_pb";
import type { UserWorkingTimeModelDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import type { UserWorkingTimeModelFiltersDtoSchema } from "../Messages/Filters_pb";
import { file_Messages_Filters } from "../Messages/Filters_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/UserWorkingTimeModelService.proto.
 */
export const file_Services_UserWorkingTimeModelService: GenFile = /*@__PURE__*/
  fileDesc("CipTZXJ2aWNlcy9Vc2VyV29ya2luZ1RpbWVNb2RlbFNlcnZpY2UucHJvdG8y5AoKG1VzZXJXb3JraW5nVGltZU1vZGVsU2VydmljZRKuAgoXR2V0VXNlcldvcmtpbmdUaW1lTW9kZWwSPi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkV2l0aERlbGV0ZWRJdGVtU2VsZWN0aW9uRHRvGkAudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5Vc2VyV29ya2luZ1RpbWVNb2RlbERldGFpbGVkRHRvIpABoNrNDwKC0+STAoQBWjY6ASoiMS9hcGkvdXNlcldvcmtpbmdUaW1lTW9kZWwvZ2V0VXNlcldvcmtpbmdUaW1lTW9kZWwSSi9hcGkvdXNlcldvcmtpbmdUaW1lTW9kZWwvZ2V0VXNlcldvcmtpbmdUaW1lTW9kZWwve2lkLmhpZ2hfNjR9L3tpZC5sb3dfNjR9EuUBChhHZXRVc2VyV29ya2luZ1RpbWVNb2RlbHMSPi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmZpbHRlcnMuVXNlcldvcmtpbmdUaW1lTW9kZWxGaWx0ZXJzRHRvGkUudGltZV90cmFja2luZy5tZXNzYWdlcy5jb2xsZWN0aW9ucy5Vc2VyV29ya2luZ1RpbWVNb2RlbENvbGxlY3Rpb25EdG8iQqDazQ8CgtPkkwI3OgEqIjIvYXBpL3VzZXJXb3JraW5nVGltZU1vZGVsL2dldFVzZXJXb3JraW5nVGltZU1vZGVscxLbAQoaQ3JlYXRlVXNlcldvcmtpbmdUaW1lTW9kZWwSNS50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLlVzZXJXb3JraW5nVGltZU1vZGVsRHRvGkAudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5Vc2VyV29ya2luZ1RpbWVNb2RlbERldGFpbGVkRHRvIkSg2s0PAILT5JMCOToBKiI0L2FwaS91c2VyV29ya2luZ1RpbWVNb2RlbC9jcmVhdGVVc2VyV29ya2luZ1RpbWVNb2RlbBKxAgoaVXBkYXRlVXNlcldvcmtpbmdUaW1lTW9kZWwSNS50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLlVzZXJXb3JraW5nVGltZU1vZGVsRHRvGkAudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5Vc2VyV29ya2luZ1RpbWVNb2RlbERldGFpbGVkRHRvIpkBoNrNDwCC0+STAo0BOgEqWjk6ASoiNC9hcGkvdXNlcldvcmtpbmdUaW1lTW9kZWwvdXBkYXRlVXNlcldvcmtpbmdUaW1lTW9kZWwaTS9hcGkvdXNlcldvcmtpbmdUaW1lTW9kZWwvdXBkYXRlVXNlcldvcmtpbmdUaW1lTW9kZWwve2lkLmhpZ2hfNjR9L3tpZC5sb3dfNjR9EpkCChpEZWxldGVVc2VyV29ya2luZ1RpbWVNb2RlbBImLnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuY29tbW9uLlV1aWREdG8aQC50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmRldGFpbGVkLlVzZXJXb3JraW5nVGltZU1vZGVsRGV0YWlsZWREdG8ikAGg2s0PAILT5JMChAFaOToBKiI0L2FwaS91c2VyV29ya2luZ1RpbWVNb2RlbC9kZWxldGVVc2VyV29ya2luZ1RpbWVNb2RlbCpHL2FwaS91c2VyV29ya2luZ1RpbWVNb2RlbC9kZWxldGVVc2VyV29ya2luZ1RpbWVNb2RlbC97aGlnaF82NH0ve2xvd182NH1CJKoCIU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5TZXJ2aWNlc2IGcHJvdG8z", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Basic, file_Messages_Collections, file_Messages_Common, file_Messages_Detailed, file_Messages_Filters, file_Options_MethodOptions]);

/**
 * Operations for mapping Identity users to working time models.
 *
 * @generated from service UserWorkingTimeModelService
 */
export const UserWorkingTimeModelService: GenService<{
  /**
   * Fetch a user and working time model association specified by its id.
   * Policy: Users can only fetch associations belonging to them.
   *
   * @generated from rpc UserWorkingTimeModelService.GetUserWorkingTimeModel
   */
  getUserWorkingTimeModel: {
    methodKind: "unary";
    input: typeof UuidWithDeletedItemSelectionDtoSchema;
    output: typeof UserWorkingTimeModelDetailedDtoSchema;
  },
  /**
   * Fetch user and working time model associations according to filters.
   * Policy: Users can only fetch associations belonging to them.
   *
   * @generated from rpc UserWorkingTimeModelService.GetUserWorkingTimeModels
   */
  getUserWorkingTimeModels: {
    methodKind: "unary";
    input: typeof UserWorkingTimeModelFiltersDtoSchema;
    output: typeof UserWorkingTimeModelCollectionDtoSchema;
  },
  /**
   * Create a new user and working time model association.
   *
   * @generated from rpc UserWorkingTimeModelService.CreateUserWorkingTimeModel
   */
  createUserWorkingTimeModel: {
    methodKind: "unary";
    input: typeof UserWorkingTimeModelDtoSchema;
    output: typeof UserWorkingTimeModelDetailedDtoSchema;
  },
  /**
   * Modify user and working time model association properties.
   *
   * @generated from rpc UserWorkingTimeModelService.UpdateUserWorkingTimeModel
   */
  updateUserWorkingTimeModel: {
    methodKind: "unary";
    input: typeof UserWorkingTimeModelDtoSchema;
    output: typeof UserWorkingTimeModelDetailedDtoSchema;
  },
  /**
   * Delete the user and working time model association with the given id.
   *
   * @generated from rpc UserWorkingTimeModelService.DeleteUserWorkingTimeModel
   */
  deleteUserWorkingTimeModel: {
    methodKind: "unary";
    input: typeof UuidDtoSchema;
    output: typeof UserWorkingTimeModelDetailedDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_UserWorkingTimeModelService, 0);

